import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Checkbox from "../CheckBox/CheckBox";
import toast, { Toaster } from "react-hot-toast";
import "./Main.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/home";
  const [isChecked, setIsChecked] = useState(false);
  
  const openPopup = () => {
    let popup = document.getElementById("popup");
    popup.classList.add("open-popup");
  };

  const closePopup = () => {
      setIsChecked(false)

    let popup = document.getElementById("popup");
    popup.classList.remove("open-popup");
  };
  const handleMemberLogin = () => {
    navigate("/member_login");
  };
  const handleAdminLogin = () => {
    navigate("/login");
  };
  const handleRegistration = () => {
    navigate("/registration");
  };

  const handleAgreement = (e) => {
		// const name = e.target.name;
		// const value = e.target.checked;
		// setState({
		// 	...state,
		// 	[name]: value,
		// 	isChecked: value,
		// 	regInformation: !state.regInformation,
		// });
	};

  const mainForm = (
    <>
      <form>
        <div className="login-box">
          <h3>Login</h3>
          <h4>Select Login Type</h4>
        </div>

        <button
          onClick={handleMemberLogin}
          type="button"
          value="Login"
          className="main-btn btn-success"
        >
          Member Login
        </button>
        <button
          onClick={handleAdminLogin}
          type="button"
          value="Login"
          className="main-btn btn-success"
        >
          Admin Login
        </button>
      </form>
    </>
  );

  const joinForm = (
		<>
			<div className="join-box">
				<h3>Join ProForum</h3>
				<h4>
					Join NDC Professionals Forum by completing the Online
					Application Form
				</h4>
				<Link onClick={openPopup} className="main-btn btn-success ">
					Join
				</Link>
			</div>

			<div className="popup" id="popup">
				<div className="popup-image">
					<img src="/images/logos/proforum_main.jpg" alt="proforum" />
				</div>
				<div className="info">
					<h2>Registration Information</h2>
					<h3>To apply for NDC Professionals Forum membership</h3>
					<h3>
						you shall be required to pay a subscription fee of
						GHS1,000.00{" "}
					</h3>
				</div>
				<hr />
				<div className="checkbox-wrapper">
					<Checkbox
						label="I accept the registration information"
						// checked={state.isChecked}
						handleAgreement={handleAgreement}
					/>
					<div className="row">
						<div className="col-sm-6">
							<button
								type="button"
								className="btn btn-success btn-block"
								onClick={handleRegistration}
								// disabled={state.regInformation}
							>
								Next
							</button>
						</div>
						<div className="col-sm-6">
							<button
								onClick={closePopup}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);

  const boxGroup = (
    <>
      {/* <div className="box">
        <a href="/election_information" target="blank">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Proforum Election</h3>
        </a>
      </div> */}
      <div className="box">
        <a href="https://ndcprofessionals.com/" target="blank">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Visit Us</h3>
        </a>
      </div>
      <div className="box">
        <a href="/contact">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Contact Us</h3>
        </a>
      </div>
      <div className="box">
        <a href="/main_2m2_payments">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">2M2</h3>
        </a>
      </div>
      <div className="box">
        <a href="/admission_fees">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Admission Fees</h3>
        </a>
      </div>
      <div className="box">
        <a href="/yearly_dues">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Yearly Dues</h3>
        </a>
      </div>
      <div className="box">
        <a href="/special_donations">
          <div className="icon">
            <img src="/images/logos/proforum.jpg" alt="Proforum" />
          </div>
          <h3 className="title">Donations</h3>
        </a>
      </div>
    </>
  );

  return (
    <>
      <section className="content-header">
        <Toaster toastOptions={{ position: "top-center" }} />
        <h1>
          <i className="fa-solid fa-children"></i> NDC Professionals Forum
        </h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="panel-title">
                      <span>
                        <strong>MMS LANDING PAGE</strong>
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="panel-body">
                <div className="index-container">
                  <div className="left">
                    {mainForm}
                    {joinForm}
                  </div>
                  <div className="right">{boxGroup}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LandingPage;
